import { DOCUMENT } from '@angular/common';
import { ɵɵdefineInjectable, ɵɵinject, Injectable, Inject } from '@angular/core';
import { isTouchScreen } from '@aw/ads-components/src/utils';

import * as ɵngcc0 from '@angular/core';
class FocusQueueService {
    constructor(_document) {
        this._document = _document;
        this._focusQueue = [];
    }
    save(enableForTouchScreen = false, restoreFocusEl) {
        if ((!enableForTouchScreen && isTouchScreen()) || !this._document.activeElement) {
            return false;
        }
        this._focusQueue.push(restoreFocusEl ? this._document.querySelector(restoreFocusEl) || this._document.activeElement : this._document.activeElement);
        return true;
    }
    restore(enableForTouchScreen = false) {
        if (!enableForTouchScreen && isTouchScreen()) {
            return false;
        }
        const focusedEl = this._focusQueue.pop();
        if (focusedEl && this._document.body.contains(focusedEl)) {
            focusedEl.focus();
            return true;
        }
        return false;
    }
    nextInQueue() {
        const focusedEl = this._focusQueue[this._focusQueue.length - 1];
        return !!focusedEl && this._document.body.contains(focusedEl);
    }
}
FocusQueueService.ɵfac = function FocusQueueService_Factory(t) { return new (t || FocusQueueService)(ɵngcc0.ɵɵinject(DOCUMENT)); };
FocusQueueService.ɵprov = ɵɵdefineInjectable({ factory: function FocusQueueService_Factory() { return new FocusQueueService(ɵɵinject(DOCUMENT)); }, token: FocusQueueService, providedIn: "root" });
FocusQueueService.ctorParameters = () => [
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FocusQueueService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

export { FocusQueueService };

//# sourceMappingURL=aw-ads-components-src-services-focus-queue.js.map